import styled from 'styled-components'

export const ModalGradientOverlay = styled.div.attrs((props) => ({
  id: 'modalOverlay',
}))`
  position: fixed;
  top: 0;
  left: 0;
  /* z-index: 99; */
  opacity: 1;
  background: radial-gradient(
    circle at 50% 50%,
    hsla(210, 19%, 16%, 0.6),
    hsla(214, 19%, 15%, 0.6),
    hsla(210, 18%, 13%, 0.6),
    hsla(213, 19%, 12%, 0.6),
    hsla(216, 19%, 10%, 0.6),
    hsla(210, 18%, 9%, 0.7),
    hsla(214, 19%, 7%, 0.7),
    hsla(204, 17%, 6%, 0.8),
    hsla(210, 18%, 4%, 0.9),
    hsla(220, 20%, 3%, 1),
    hsla(180, 14%, 1%, 1),
    hsla(0, 0%, 0%, 1)
  );
  width: 100vw;
  height: 100vh;
  -webkit-transition: opacity 0.5s ease;
  -moz-transition: opacity 0.5s ease;
  -o-transition: opacity 0.5s ease;
  transition: opacity 0.5s ease;
  ${({ theme }) => theme.breakPoints['480px']} {
    //background: rgba(25, 30, 39, 0.8);
    &:before {
      position: absolute;
      filter: blur(350px);
      width: 100vw;
      height: 100vh;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: -2;
      content: '';
      border-radius: 50%;
    }
  }
`
